// extracted by mini-css-extract-plugin
export default {"question":"Question_question__YJiV6","line":"Question_line__ctuli"};